import React, { useContext } from "react";
import { Button, Icon, Select } from "antd";
import style from "./index.module.scss";
import { useHistory } from "react-router-dom";
import { CourseContext, CoursePlanAtom } from "../../../../Store";
import { useAtomValue } from "jotai";
import { number2WeekHanzi, sectionDescribe } from "Utils/filter";
import { courseDetailUrl } from "API/urls";

export default function SectionPicker() {
    const { course, path } = useContext(CourseContext);
    const history = useHistory();

    const list = useAtomValue(
        CoursePlanAtom({
            courseNo: course.courseNo,
            courseSeq: course.courseSeq
        })
    );

    function handlerSelectChange(weekTimeId: number) {
        history.replace(
            courseDetailUrl(course.courseNo, course.courseSeq, weekTimeId, path)
        );
    }

    const index = list.findIndex(
        item => Number(item.weekTimeId) === course.weekTimeId
    );

    function handleCheck(index: number) {
        const newWeekTimeId = Number(list[index].weekTimeId);
        handlerSelectChange(newWeekTimeId);
    }

    if (!list) return null;

    return (
        <div className={style.root}>
            <Button
                type="link"
                className={style.arrBtn}
                onClick={() => handleCheck(index - 1)}
                disabled={index === 0}>
                <Icon type="left" className={style.icon} />
            </Button>

            <Select
                className={style.select}
                value={course.weekTimeId}
                onChange={handlerSelectChange}
                dropdownClassName={style.dropdown}
                showArrow={false}>
                {list.map(item => (
                    <Select.Option
                        value={item.weekTimeId}
                        key={item.weekTimeId}>
                        第{item.weekTime}周{" "}
                        {number2WeekHanzi(Number(item.week))}{" "}
                        {sectionDescribe(item.section, item.continunity)}
                    </Select.Option>
                ))}
            </Select>

            <Button
                type="link"
                className={style.arrBtn}
                onClick={() => handleCheck(index + 1)}
                disabled={index === list.length - 1}>
                <Icon type="right" className={style.icon} />
            </Button>
        </div>
    );
}
